import { HttpClient, HttpHeaders ,HttpEvent} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariables } from 'global-variables';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  private url = GlobalVariables.appURL;
  private headers: HttpHeaders = new HttpHeaders();

  constructor(private _httpClient: HttpClient) {
    this.headers.append('Content-Type', 'multipart/form-data');
  }

// constructor(private _httpClient: HttpClient) {}

  public setFeaturedListPriority(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'products/featuredlistpriority', data);
  }
  public IsFeaturedListingActive(id: any,isFeatured:Boolean): Observable<any> {
    return this._httpClient.patch(this.url + 'products/featured-listing-active/' + id,{isFeatured:isFeatured});
  }

  public getProductList(): Observable<any> {
    return this._httpClient.get(this.url + 'products');
  }

  public list(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'products/list', data);
  }

  public detail(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'products/' + id);
  }

  public productVarientUploadStatus(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'products/variant-upload-status/' + id);
  }
  public pvdetail(id: any,vid:any): Observable<any> {
    return this._httpClient.get(this.url + 'products/' + id + '/varient/'+ vid) ;
  }

  public padetail(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'products-attribute/' + id) ;
  }

  public delete(id: any): Observable<any> {
    return this._httpClient.delete(this.url + 'products/' + id);
  }

  public vardelete(id: any): Observable<any> {
    return this._httpClient.delete(this.url + 'product-variant/' + id);
  }

  public create(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'products', data, {headers: this.headers});
  }

  public createVarient(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'products-variant', data, {headers: this.headers});
  }

  // public update(productId: string, data: any): Observable<any> {
  //   return this._httpClient.patch(this.url + 'products/' + productId, data, {headers: this.headers});
  // }

public update(productId: string, data: FormData): Observable<any> {
  return this._httpClient.patch( this.url + 'products/' + productId, data);
}

  public updateFeaturedData(productId: string, data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'products/' + productId  + `/featured`, data, {headers: this.headers});
  }

  public updatevarient(productId: string, productVarientId:string,data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'product-variant/' + productId + "/" + productVarientId, data, {headers: this.headers});
  }


  public uploadProductVariants(body: any): Observable<any> {
    return this._httpClient.post(this.url + 'product-variant/upload', body);
  }
  
  
  public productVariantList(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'product-variant/list', data);
  }

  public errorlist(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'products/errorlist', data);
  }

  public  addProductFile(productId: string, formData: FormData) {
    return this._httpClient.post(`${this.url}products/${productId}/files`, formData);
  }

  
  public deleteProductFile(productId: string, productImages:any ,index: any) {
    return this._httpClient.delete(this.url +`products/${productId}/files/${productImages}/${index}`);
  }
  
  public reorderProductFiles(productId: string, body: any) {
    return this._httpClient.patch(this.url +`products/${productId}/files/reorder`, body);
  }


  // uploadFile(file: File): Observable<HttpEvent<any>> {
  //   const fd = new FormData();
  //   fd.append('file', file);
  //   return this._httpClient.post<any>(this.url, fd, {
  //     reportProgress: true,
  //     observe: 'events'
  //   });
  // }

  // uploadFiles(files: File[]): Observable<HttpEvent<any>> {
  //   const fd = new FormData();
  //   files.forEach((f, i) => fd.append('files', f));
  //   return this._httpClient.post<any>(this.url + '/multiple', fd, {
  //     reportProgress: true,
  //     observe: 'events'
  //   });
  // }
}
